import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'homepage',
    pathMatch: 'full'
  },
  {
    path: 'homepage',
    loadChildren: () => import('./homepage/homepage.module').then(m => m.HomepagePageModule)
  },
  {
    path: 'articles',
    loadChildren: () => import('./articles/articles.module').then( m => m.ArticlesPageModule)
  },
  {
    path: 'articles/:id',
    loadChildren: () => import('./indexes/indexes.module').then( m => m.IndexesPageModule)
  },
  {
    path: 'indexes',
    loadChildren: () => import('./indexes/indexes.module').then( m => m.IndexesPageModule)
  },
  {
    path: 'indexes/:id',
    loadChildren: () => import('./blocks/blocks.module').then( m => m.BlocksPageModule)
  },
  {
    path: 'blocks',
    loadChildren: () => import('./blocks/blocks.module').then( m => m.BlocksPageModule)
  },
  {
    path: 'fullview/:id',
    loadChildren: () => import('./full-view/full-view.module').then( m => m.FullViewPageModule)
  },
  {
    path: '**',
    redirectTo: 'homepage',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
